const DifferentFromValidator = () => {
  const require = 'ngModel'

  const scope = { otherModelValue: '=differentFrom' }

  const link = (scope, element, attrs, ctrl) => {
    ctrl.$validators.differentFrom = (modelValue, viewValue) => modelValue !== scope.otherModelValue
    scope.$watch('otherModelValue', () => ctrl.$validate())
  }

  return { require, scope, link }
}

export default DifferentFromValidator



// WEBPACK FOOTER //
// ./src/app/common/validators/different-from.validator.js